import type { TtsRegion } from "@unbox/api";

const getAffiliateHost = (region: TtsRegion | undefined): string => {
  switch (region) {
    case "US":
      return "https://affiliate-us.tiktok.com";
    default:
      return "https://affiliate.tiktok.com";
  }
};

/**
 * Builds the TikTok Shop collaboration detail URL.
 *
 * @param collaborationId - The collaboration ID (invitation_id in TikTok's system)
 * @param region - The TTS region (e.g., "US", "GB")
 * @returns The full URL to the collaboration detail page on TikTok Shop
 */
export const buildTikTokCollaborationUrl = (collaborationId: string, region: TtsRegion | undefined): string => {
  return `${getAffiliateHost(region)}/connection/target-invitation/detail?invitation_id=${collaborationId}`;
};

/**
 * Builds the TikTok Shop target collaboration setup URL.
 */
export const buildTikTokTargetCollaborationSetupUrl = (region: TtsRegion | undefined): string => {
  return `${getAffiliateHost(region)}/connection/target-invitation`;
};

/**
 * Builds the TikTok Shop open collaboration setup URL.
 */
export const buildTikTokOpenCollaborationSetupUrl = (region: TtsRegion | undefined): string => {
  return `${getAffiliateHost(region)}/product/open-collaboration`;
};

const TIKTOK_ADS_BASE_URL = "https://ads.tiktok.com/i18n";

/**
 * Builds the TikTok Ads campaign list URL, opened on the given advertiser when there is one.
 */
export const buildTikTokAdsCampaignsUrl = (advertiserId: string | null | undefined): string => {
  return advertiserId ? `${TIKTOK_ADS_BASE_URL}/campaign?aadvid=${advertiserId}` : `${TIKTOK_ADS_BASE_URL}/campaign`;
};

/**
 * Builds the TikTok Ads URL for one campaign of an advertiser.
 */
export const buildTikTokAdsCampaignUrl = (advertiserId: string, campaignId: string): string => {
  return `${TIKTOK_ADS_BASE_URL}/perf/campaign?aadvid=${advertiserId}&keyword=${campaignId}`;
};
